import { h } from 'preact'
import FirebaseComponent from './FirebaseComponent'
import UserDetailDisplay from './UserDetailDisplay'
import UserLastLogin from './UserLastLogin'
import EventsTable from './EventsTable'
import Calendar from './Calendar'
import './Dashboard.css'

class Dashboard extends FirebaseComponent {
  render() {
    return (
      <div className='container'>
				<div className="row">
						<div className="col-sm-6">
							<UserDetailDisplay />
						</div>
						<div className="col-sm-6 dashboard-right-side">
							<UserLastLogin />
						</div>
				</div>
				<div className="row">
					<div className="col-sm-6">
            <Calendar />
					</div>
					<div className="col-sm-6">
						<EventsTable />
					</div>
				</div>
		</div>
    );
  }
}

export default Dashboard



// WEBPACK FOOTER //
// ./src/Dashboard.js